import { INVOICE_BATCH_NOTE_CATEGORY_LIST_ERROR, INVOICE_BATCH_NOTE_CATEGORY_LIST_RECEIVED, INVOICE_BATCH_NOTE_CATEGORY_LIST_REQUEST } from '../constants';

const reducer = (
  state = {
    invoiceBatchNoteCategories: [],
    isFetchingInvoiceBatchNoteCategories: false,
  },
  action,
) => {
  switch (action.type) {
    case INVOICE_BATCH_NOTE_CATEGORY_LIST_REQUEST:
      state = {
        ...state,
        isFetchingInvoiceBatchNoteCategories: true,
      };
      return state;

    case INVOICE_BATCH_NOTE_CATEGORY_LIST_RECEIVED:
      //      console.log({cats: action.data['hydra:member']});
      state = {
        ...state,
        invoiceBatchNoteCategories: action.data['hydra:member'],
        isFetchingInvoiceBatchNoteCategories: false,
      };
      return state;

    case INVOICE_BATCH_NOTE_CATEGORY_LIST_ERROR:
      state = {
        ...state,
        isFetchingInvoiceBatchNoteCategories: false,
      };
      return state;

    default:
      return state;
  }
};

export default reducer;
